import { locationsProfilesConstants } from '@constants/locations-profiles';

const initialState = {
    data: [],
    loading: false,
    error: null,
    ownerId: null,
    requestId: null,
};

const isCurrentRequest = (state, action) => action.ownerId === state.ownerId && action.requestId === state.requestId;

export function locationsProfiles(state = initialState, action) {
    switch (action.type) {
        case locationsProfilesConstants.LOCATIONS_PROFILES_FETCH:
            return {
                ...state,
                loading: true,
                ownerId: action.ownerId,
                requestId: action.requestId,
                data: action.ownerId === state.ownerId ? state.data : [],
            };
        case locationsProfilesConstants.LOCATIONS_PROFILES_SUCCESS:
            if (!isCurrentRequest(state, action)) return state;
            return { ...state, loading: false, data: action.data };
        case locationsProfilesConstants.LOCATIONS_PROFILES_ERROR:
            if (!isCurrentRequest(state, action)) return state;
            return { ...state, loading: false };
        case locationsProfilesConstants.LOCATIONS_PROFILES_RESET:
            return { ...initialState };
        default:
            return state;
    }
}
